import { createContext, useContext } from 'react';

interface AttachmentDisplayContextType {
  preview: boolean;
  removeButton?: boolean;
}

export const AttachmentDisplayContext =
  createContext<AttachmentDisplayContextType>({
    preview: true,
    removeButton: true,
  });

export const useAttachmentDisplayContext = (): AttachmentDisplayContextType => {
  return useContext(AttachmentDisplayContext);
};
